<template>
    <b-row>
        <b-col cols="12" class="pt-3">
            <ContentOrLoading>
                <b-table
                    v-if="data.data"
                    striped
                    hover
                    :items="data.data"
                    :fields="[
                        { key: 'id', label: 'ID' },
                        { key: 'boletin_enviado', label: 'Asunto' },
                        { key: 'created_at', label: 'Creado en' }
                    ]"
                    :busy="loading"
                    show-empty
                >
                    <template #empty>
                        <h4 class="text-center">No hay ningún resultado</h4>
                    </template>
                    <template #cell(boletin_enviado)="data">
                        <b-link :to="{ name: 'back.emails.boletines.show', params: { id: data.item.boletin_id } }">
                            {{ data.item.boletin_enviado }}
                        </b-link>
                    </template>
                </b-table>
                <b-pagination
                    v-if="data.meta"
                    v-model="data.meta.current_page"
                    :total-rows="data.meta.total"
                    :per-page="data.meta.per_page"
                    @page-click="pageClicked"
                />
            </ContentOrLoading>
        </b-col>
    </b-row>
</template>

<script>
    import apiService from '@/services/api-comunicados';

    export default {
        name: 'SubscriptorEmailsVisualizaciones',
        props: {
            subscriptor: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                data: {}
            };
        },
        methods: {
            getVisualizaciones(page = 1) {
                try {
                    this.loading = true;
                    apiService.getSubscriptorMailVisualizaciones(this.subscriptor.id, { page: page }).then(response => {
                        this.data = response;
                    }).catch(error => {
                        console.error("Error fetching subscriptor:", error);
                    }).finally(() => {
                        this.loading = false;
                    });
                } catch (error) {
                    console.error("Error in getSubscriptor method:", error);
                }
            },
            pageClicked(event, page) {
                this.getVisualizaciones(page);
            }
        },
        mounted() {
            this.getVisualizaciones();
        }
    }
</script>